var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { components } from 'react-select';
import SubMenu from './SubMenu';
import PopoverContent from './PopoverContent';
// @TODO remove SubMenu components and logic when redesign is done
var SubMenusMenuList = function (menuListProps) {
    var _a, _b;
    var children = menuListProps.children, getValue = menuListProps.getValue, selectOption = menuListProps.selectOption, props = __rest(menuListProps, ["children", "getValue", "selectOption"]);
    var _c = (children[0] || children).props, isFocused = _c.isFocused, isSelected = _c.isSelected, innerProps = _c.innerProps, optionProps = __rest(_c, ["isFocused", "isSelected", "innerProps"]);
    var _d = menuListProps.selectProps, subMenus = _d.subMenus, inputValue = _d.inputValue, themeFamily = _d.themeFamily;
    var currentValue = (_b = (_a = getValue()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value;
    return (_jsxs(_Fragment, { children: [_jsx(components.MenuList, __assign({}, props, { children: children }), void 0),
            _jsx(SubMenusContainer, { children: subMenus === null || subMenus === void 0 ? void 0 : subMenus.map(function (subMenu) {
                    var triggerText = subMenu.triggerText, description = subMenu.description, options = subMenu.options;
                    return (_jsx(SubMenu, { triggerText: triggerText, description: description, options: options, optionProps: optionProps, inputValue: inputValue, currentValue: currentValue, selectOption: selectOption, themeFamily: themeFamily }, triggerText));
                }) }, void 0),
            _jsx(PopoverContent, __assign({}, menuListProps), void 0)] }, void 0));
};
var SubMenusContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 12px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0 0 6px 6px;\n  background: ", ";\n"], ["\n  padding: 0 12px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0 0 6px 6px;\n  background: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
export default SubMenusMenuList;
var templateObject_1;
